import * as React from 'react';
import { useLocalStorage } from '@grandvisionhq/utils';

const useWishlistStorage = ()=>{
    const shouldRemove = React.useCallback((value)=>value === undefined
    , []);
    const [localShoppingList, setLocalShoppingList] = useLocalStorage('wishlist', (()=>{
        if (typeof window !== 'undefined') {
            const storedWishlist = window.localStorage.getItem('wishlist');
            return storedWishlist ? JSON.parse(storedWishlist) : undefined;
        }
        return undefined;
    })(), shouldRemove);
    return React.useMemo(()=>[
            localShoppingList,
            setLocalShoppingList
        ]
    , [
        localShoppingList,
        setLocalShoppingList
    ]);
};

export { useWishlistStorage };
//# sourceMappingURL=use-wishlist-storage.js.map
